import { Box } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import CloseIcon from '../Icons/CloseIcon';
import { FilterTagContainer } from './FilterTagStyle';

interface FilterTagProps extends PropsWithChildren {
  onClick?: () => void;
  onRemove?: () => void;
}
function FilterTag({ onClick, onRemove, children }: FilterTagProps) {
  return (
    <FilterTagContainer onClick={onClick}>
      <CloseIcon stroke="#000" onClick={onRemove} style={{ cursor: 'pointer', transform: 'scale(0.75)' }} />
      <Box>{children}</Box>
    </FilterTagContainer>
  );
}

export default FilterTag;
